import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../store'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import {
  WelcomerState,
  clearAddon,
  clearGroupAddon,
  removeAddon,
  removeGroupAddon,
  setAddon,
  setAllPrices,
  setChooseMethod,
  setCompanyOffers,
  setCurrency,
  setCurrencyId,
  setGroupAddon,
  setHeaderPassedCount,
  setIsCompanyFromUser,
  setLimit,
  setLimitId,
  setOffer,
  setSelectedCompanies,
  updateAddon,
  updateGroupAddon,
  updateWelcomerDatesPrices,
} from '../../../store/welcomerSlice'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import RightArrow from '../../../assets/icons/JSX/RightArrow'
import CubesIcon from '../../../assets/v2/JSX/CubesIcon'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import WelcomerProgressbar from '../../../components/v2/progrees-bars/WelcomerProgressbar'
import { Container } from '../../../assets/styles/GlobalStyle'
import Dropdown from '../../../components/v2/Dropdown'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import PriceAccordion from '../../../components/v2/accordions/PriceAccordion'
import CountBar from '../../../components/v2/CountBar'
import DoubleRightIcon from '../../../assets/icons/JSX/DoubleRightIcon'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { currencySymbol, WelcomersDatePrices, georgianFormatter } from '../../../domain/types'
import api from '../../../api'
import { toast } from 'react-toastify'
import Loader from '../../../components/Loader'
import { isEqual } from 'lodash'
import { Helmet } from 'react-helmet-async'
import { AppState } from '../../../store/appSlice'

const WelcomerOffers = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { welcomer: WelcomerState }) => data.welcomer)
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetWelcomerPagesInfoQuery('welcomer-choose-offer')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  //
  //
  const isDataValid = (data: any) => {
    if (!Array.isArray(data)) {
      return false
    }

    for (let i = 0; i < data.length; i++) {
      const item = data[i]
      if (
        item.age === null ||
        item.age === 0 ||
        item.date === null ||
        item.date.length !== 14 ||
        Number(item.age) < 0
      ) {
        return false
      }
    }

    return true
  }
  //
  //
  const [getLeftCompanies, { data: leftCompanies, isLoading: isLeftCompanyLoading, reset }] =
    api.useWelcomerLeftCompaniesLastStepMutation()
  //
  //
  const { data: WelcomerCurrencies, isLoading: isWelcomerCurrenciesLoading } =
    api.useGetWelcomerCurrencyListQuery(undefined)
  //
  const { data: WelcomerLimits, isLoading: isWelcomerLimitsLoading } = api.useGetWelcomerLimitListQuery(undefined)
  //
  const [welcomerOffers, { isLoading: isWelcomerOffersLoading, data: welcomerBestOffers }] =
    api.useWelcomerBestOfferMutation()
  //
  useEffect(() => {
    if (
      filter.productCategory &&
      filter.welcomersDate &&
      filter.welcomersDate !== undefined &&
      filter.welcomersDate.length >= 1 &&
      isDataValid(filter.welcomersDate) &&
      filter.currency &&
      filter.singleDates?.start &&
      filter?.singleDates?.end
    ) {
      const GetCompaniesFunction = async () => {
        try {
          //
          await getLeftCompanies({
            step: 'step-three',
            productCategory: filter.productCategory,
            startDate: filter.singleDates?.start as string,
            endDate: filter.singleDates?.end as string,
            currency: filter.currency,
            limit: filter.limit as number,
            // @ts-ignore
            ages: filter.welcomersDate.map((t) => (t.month === null ? t.age : 0)),
          }).unwrap()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (GetCompaniesFunction) (ChooseMethod)')
          }
        }
      }
      //
      GetCompaniesFunction()
    }

    return () => {}
  }, [
    filter.productCategory,
    filter.singleDates?.start,
    filter.singleDates?.end,
    filter.currency,
    filter.limit,
    filter.welcomersDate,
    getLeftCompanies,
  ])
  //
  //
  useEffect(() => {
    if (
      leftCompanies &&
      leftCompanies.count >= 1 &&
      welcomerOffers &&
      filter?.singleDates?.start &&
      filter?.singleDates?.end &&
      filter?.currencyId &&
      filter?.limitId &&
      filter?.welcomersDate
    ) {
      const getBestOffer = async () => {
        //
        const leftPackages = leftCompanies?.packageData.filter((x) =>
          filter?.selectedCompaniesIds?.includes(x.product?.company?.id as never),
        )

        try {
          //
          await welcomerOffers({
            days: filter?.insuranceDays,
            currencyId: filter?.currencyId,
            limitId: filter?.limitId,
            packageIds: leftPackages?.map((x) => x.id),
            // @ts-ignore
            ages: filter.welcomersDate.map((t) => (t.month === null ? t.age : 0)),
          }).unwrap()
          //
          reset()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით...')
          }
        }
      }
      //
      if (leftCompanies && leftCompanies.count >= 1) {
        getBestOffer()
      }
    }

    return () => {}
  }, [
    reset,
    filter.chooseMethod,
    filter.productCategory,
    filter.singleDates?.start,
    filter.singleDates?.end,
    filter.currency,
    filter.limit,
    filter.welcomersDate,
    filter.currencyId,
    filter.limitId,
    filter?.insuranceDays,
    filter?.selectedCompaniesIds,
    welcomerOffers,
    leftCompanies,
  ])
  //
  useEffect(() => {
    // this is for uniting the company information and prices together for every company
    if (welcomerBestOffers && leftCompanies && leftCompanies.count >= 1) {
      // const unitedOffer: WelcomerSelectCompanies[] | undefined = []

      const LeftCompanyIds = leftCompanies?.uniqueCompanies?.map((x) => x.id)

      // Compare new unitedOffer with existing companyOffers
      if (!isEqual(welcomerBestOffers, filter?.companyOffers)) {
        dispatch(setCompanyOffers(welcomerBestOffers))
      }
      //

      if (LeftCompanyIds) {
        const selectedCompaniesIds: number[] = LeftCompanyIds?.filter((id) =>
          filter?.selectedCompaniesIds?.includes(id as never),
        )

        const selectedCompanies = welcomerBestOffers.filter((offer) =>
          selectedCompaniesIds?.some(
            (companyId) =>
              offer?.prices?.map((x) => x.welcomerPackage?.mainPackage?.product?.companyId)[0] ===
              (companyId as number),
          ),
        )
        if (!isEqual(selectedCompanies, filter?.selectedCompanies)) {
          dispatch(setSelectedCompanies(selectedCompanies))
        }
        //
      }
    }
    //
    if (leftCompanies && leftCompanies?.count === 0) {
      if (!isEqual([], filter?.companyOffers)) {
        dispatch(setCompanyOffers([]))
      }

      if (!isEqual([], filter?.selectedCompanies)) {
        dispatch(setSelectedCompanies([]))
      }
    }
  }, [
    welcomerBestOffers,
    dispatch,
    filter?.companyOffers,
    filter?.selectedCompaniesIds,
    leftCompanies,
    filter.chooseMethod,
    filter?.selectedCompanies,
  ])
  //
  //
  const [openAddonAccordion, setOpenAddonAccordion] = useState<boolean>(false)
  //
  //
  useEffect(() => {
    dispatch(setChooseMethod('my-choose'))
  }, [dispatch])
  //
  //
  //
  // addons
  const atAddonsOnceTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          .filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + parseInt(item.addon.premium, 10) * item.count, 0)
      : 0
  //
  //
  const atAddonsDailyTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) =>
              accumulator + parseInt(item.addon.premium, 10) * (filter?.insuranceDays || 0) * item.count,
            0,
          )
      : 0

  //
  // groupe dAttached Addons Addons Calculate the total price
  const groupOnceAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + item.addon.premium * item.count, 0)
      : 0
  //
  //
  const groupDailyAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) => accumulator + item.addon.premium * (filter?.insuranceDays || 0) * item.count,
            0,
          )
      : 0
  //
  //
  //
  const allAddonPrice =
    atAddonsOnceTotalPrice + groupOnceAddonsTotalPrice + atAddonsDailyTotalPrice + groupDailyAddonsTotalPrice
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.singleDates?.start) {
      navigate('/welcomer-start-date')
    }
    //
    return () => {}
  }, [filter.singleDates?.start, navigate])
  //
  //
  const MainLoading =
    isWelcomerCurrenciesLoading ||
    isWelcomerLimitsLoading ||
    isWelcomerOffersLoading ||
    isLeftCompanyLoading ||
    isPageInfoLoading
  //

  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={pageTitle} />

        <WelcomerProgressbar stepName={stepName} />
      </Content>

      <Container>
        {/*  */}
        <DropDownBlock>
          <DropdownCustomStyle>
            <span className="dropdown-value-span">{t('currency')}</span>
            <Dropdown
              title={`${t('currency')}`}
              value={filter.currency}
              options={WelcomerCurrencies?.filter((x) => x.isActive === true)?.map((x) => ({
                value: x.currencyCode.toLowerCase(),
                label: x.currencyCode?.toUpperCase(),
              }))}
              placeholder={``}
              onChange={(obj) => {
                let currencyId = WelcomerCurrencies?.filter((x) => x.isActive === true)?.filter(
                  (x) => x.currencyCode.toLowerCase() === obj.value.toLowerCase(),
                )
                currencyId && dispatch(setCurrencyId(currencyId[0].id))

                dispatch(setCurrency(obj.value))
              }}
            />
          </DropdownCustomStyle>

          <VerticalLine />

          <DropdownCustomStyle>
            <span className="dropdown-value-span">{t('limit')}</span>
            <Dropdown
              title={`${t('limit')}`}
              value={filter.limit}
              options={WelcomerLimits?.filter((x) => x.isActive === true).map((x) => ({
                value: x.value,
                label:
                  x.value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
                  ` ${currencySymbol(filter.currency || 'gel')}`,
              }))}
              placeholder={``}
              onChange={(obj) => {
                let limitId = WelcomerLimits?.filter((x) => x.isActive === true)?.filter(
                  (x) => x.value === Number(obj.value),
                )
                limitId && dispatch(setLimitId(limitId[0].id))

                dispatch(setLimit(Number(obj.value)))
              }}
            />
          </DropdownCustomStyle>
        </DropDownBlock>
        {/*  */}
        {/*  */}
        {filter.companyOffers && filter.companyOffers.length >= 1 ? null : (
          <RemainingCompanies
            style={{
              marginInline: 'auto',
              width: 'fit-content',
              marginTop: '20px',
            }}
            text={t('offerNotFound')}
          />
        )}
        {/*  */}
        {/*  */}
        <Block>
          {filter.selectedCompanies &&
            filter.selectedCompanies.map((item, index) => {
              //
              //
              const showAtAddons =
                item?.prices &&
                item?.prices[0]?.welcomerPackage?.attachedAddons &&
                item?.prices[0]?.welcomerPackage?.attachedAddons?.filter((item) => typeof item === 'object')?.length >=
                  1
                  ? true
                  : false
              //
              const showGroupAtAddons =
                item?.prices &&
                item?.prices[0]?.welcomerPackage?.groupedAttachedAddonInfos &&
                item?.prices[0]?.welcomerPackage?.groupedAttachedAddonInfos?.filter((item) => typeof item === 'object')
                  ?.length >= 1
                  ? true
                  : false
              //
              return (
                <PriceAccordion
                  key={index}
                  isBestPrice={item?.isBestOption}
                  price={`${georgianFormatter.format(
                    item?.prices
                      ?.map((x) => x.premium * (filter?.insuranceDays || 1))
                      .reduce((sum, premium) => sum + Number(premium), 0) as number,
                  )}₾`}
                  docUrl={
                    item?.prices[0]?.welcomerPackage?.mainPackage?.wordingFiles?.translations?.[lang]?.url
                      ? item?.prices[0]?.welcomerPackage?.mainPackage?.wordingFiles?.translations?.[lang]?.url
                      : item?.prices[0]?.welcomerPackage?.mainPackage?.product?.wordingFileUrl?.includes('translations')
                      ? JSON.parse(item?.prices[0]?.welcomerPackage?.mainPackage?.product?.wordingFileUrl)
                          ?.translations?.[lang]?.url
                      : undefined
                  }
                  headTitle={
                    item.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.translations?.[lang]?.title
                  }
                  imgUrl={item.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.logo}
                  isSelected={
                    item.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.id ===
                    filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id
                      ? true
                      : false
                  }
                  addonsPrice={
                    item.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.id ===
                      filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id && allAddonPrice
                      ? `${allAddonPrice} ₾`
                      : ''
                  }
                  onClick={() => {
                    if (
                      item.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.id ===
                      filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id
                    ) {
                      return [
                        dispatch(setOffer(undefined)),
                        dispatch(setIsCompanyFromUser(false)),
                        dispatch(clearAddon([])),
                        dispatch(clearGroupAddon([])),
                      ]
                    } else {
                      let updatedWelcomersDate: WelcomersDatePrices[] | undefined = filter?.welcomersDate?.map((x) => {
                        return {
                          age: x.age,
                          date: x.date,
                          priceId:
                            item?.prices?.find(
                              (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                            )?.id || 0,
                          premium:
                            item?.prices?.find(
                              (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                            )?.premium || 0,
                          welcomerAgeGroupId:
                            item?.prices?.find(
                              (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                            )?.welcomerAgeGroupId || 0,
                          welcomerDayGroupId:
                            item?.prices?.find(
                              (b) => b.welcomerAgeGroup?.ageFrom <= x.age && b.welcomerAgeGroup?.ageTo >= x.age,
                            )?.welcomerDayGroupId || 0,
                        }
                      })

                      return [
                        dispatch(setOffer(item.prices[0])),
                        dispatch(updateWelcomerDatesPrices(updatedWelcomersDate as any)),
                        dispatch(setAllPrices(item.prices?.map((x) => x.premium))),
                        dispatch(setIsCompanyFromUser(true)),
                        dispatch(clearAddon([])),
                        dispatch(clearGroupAddon([])),
                      ]
                    }
                  }}
                >
                  {/* CONTENT */}
                  <HR />

                  <TextDiv>
                    <LeftText>{t('currency')}</LeftText>
                    <RightText>{filter.currency && filter?.currency?.toUpperCase()}</RightText>
                  </TextDiv>

                  <TextDiv>
                    <LeftText>{t('limit')}</LeftText>
                    <RightText>
                      {filter.limit && filter?.limit.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}{' '}
                      {currencySymbol(
                        (item?.prices &&
                          item?.prices[0]?.welcomerPackage?.mainPackage?.compensationCurrencies[0].currency) ||
                          'gel',
                      )}
                    </RightText>
                  </TextDiv>

                  {showAtAddons || showGroupAtAddons ? (
                    <>
                      <HR />

                      <AddonsBlock>
                        <AddonAccordion>
                          <AddonHead onClick={() => setOpenAddonAccordion(!openAddonAccordion)}>
                            <CubesIconStyle />
                            <span>{t('additionalCoverages')}</span>
                            <RightArrowStyle
                              style={{
                                transform: openAddonAccordion ? 'rotate(-90deg)' : 'rotate(90deg)',
                              }}
                            />
                          </AddonHead>
                          {openAddonAccordion ? (
                            <AddonsContent
                              style={{
                                opacity:
                                  item.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.id ===
                                  filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id
                                    ? 'unset'
                                    : '0.7',
                                pointerEvents:
                                  item.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.id ===
                                  filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id
                                    ? 'unset'
                                    : 'none',
                                userSelect:
                                  item.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.id ===
                                  filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id
                                    ? 'unset'
                                    : 'none',
                              }}
                            >
                              {item?.prices &&
                                item?.prices[0]?.welcomerPackage?.attachedAddons &&
                                item?.prices[0]?.welcomerPackage?.attachedAddons
                                  .filter((x) => x && x.addonId)
                                  ?.map((atAddon, atAddonIndex) => {
                                    //
                                    const attachedAddonsInitialCount =
                                      item.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.id ===
                                        filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id &&
                                      filter.attachedAddons?.find((x) => x.addon.addonId === atAddon.addonId)
                                    //
                                    return (
                                      <StandartAddon key={atAddonIndex}>
                                        <StandartAddonLeftSide>
                                          <span>{atAddon.addon?.translations?.[lang]?.title}</span>
                                          <span>
                                            {t('price')}: {atAddon.premium} ₾
                                            {atAddon.paymentType === 'ONCE' ? (
                                              <> / {t('coverageCost')}</>
                                            ) : (
                                              <> / {t('coverageCostByPerson')}</>
                                            )}
                                          </span>
                                          {filter.attachedAddons?.find((x) => x.addon.addonId === atAddon.addonId) ? (
                                            <span className="offer-addon-description">
                                              {atAddon.translations?.[lang]?.description}
                                            </span>
                                          ) : null}
                                        </StandartAddonLeftSide>
                                        <CountBar
                                          // @ts-ignore
                                          initialCount={attachedAddonsInitialCount?.count ?? 0}
                                          step={1}
                                          maxCount={filter.welcomersDate?.length}
                                          plusOnClick={(value) => {
                                            // create and set new addon
                                            if (
                                              filter.attachedAddons &&
                                              (filter.attachedAddons.length <= 0 ||
                                                filter.attachedAddons.find(
                                                  (x) => x.addon.addonId !== atAddon.addonId,
                                                )) &&
                                              value === 1
                                            ) {
                                              // create new addon
                                              dispatch(setAddon({ addon: atAddon, count: value }))
                                            }
                                            //
                                            // update addon count
                                            if (
                                              filter.attachedAddons &&
                                              filter.attachedAddons.length >= 1 &&
                                              value > 1
                                            ) {
                                              dispatch(updateAddon({ addonId: atAddon.addonId, count: value }))
                                            }
                                          }}
                                          minusOnClick={(value) => {
                                            // update addon count
                                            if (filter.attachedAddons && filter.attachedAddons.length >= 1) {
                                              dispatch(updateAddon({ addonId: atAddon.addonId, count: value }))
                                            }
                                            // remove addon by id
                                            if (
                                              filter.attachedAddons &&
                                              filter.attachedAddons.length >= 1 &&
                                              value === 0
                                            ) {
                                              //  remove addon by id
                                              dispatch(removeAddon(atAddon.addonId))
                                            }
                                          }}
                                        />
                                      </StandartAddon>
                                    )
                                  })}

                              {item?.prices &&
                                item?.prices[0]?.welcomerPackage?.groupedAttachedAddonInfos &&
                                item?.prices[0]?.welcomerPackage?.groupedAttachedAddonInfos
                                  .filter((x) => x && x.id)
                                  ?.map((groupAddon, groupAddonIndex) => {
                                    //
                                    const groupAttachedAddonsInitialCount =
                                      item.prices[0]?.welcomerPackage?.mainPackage?.product?.company?.id ===
                                        filter.offer?.welcomerPackage?.mainPackage?.product?.company?.id &&
                                      filter.groupedAttachedAddons?.find((x) => x.addon.id === groupAddon.id)
                                    //
                                    return (
                                      <GroupAddon key={groupAddonIndex}>
                                        <StandartAddon>
                                          <StandartAddonLeftSide>
                                            <span>{groupAddon.translations?.[lang]?.title}</span>
                                            <span>
                                              {t('price')}: {groupAddon.premium} ₾
                                              {groupAddon.paymentType === 'ONCE' ? (
                                                <> / {t('coverageCost')}</>
                                              ) : (
                                                <> / {t('coverageCostByPerson')}</>
                                              )}
                                            </span>
                                          </StandartAddonLeftSide>
                                          <CountBar
                                            // this ts ignore not important
                                            // @ts-ignore
                                            initialCount={groupAttachedAddonsInitialCount?.count ?? 0}
                                            step={1}
                                            maxCount={filter.welcomersDate?.length}
                                            plusOnClick={(value) => {
                                              //
                                              // create and set new addon
                                              if (
                                                filter.groupedAttachedAddons &&
                                                (filter.groupedAttachedAddons.length <= 0 ||
                                                  filter.groupedAttachedAddons.find(
                                                    (x) => x.addon.id !== groupAddon.id,
                                                  )) &&
                                                value === 1
                                              ) {
                                                // create new addon
                                                dispatch(setGroupAddon({ addon: groupAddon, count: value }))
                                              }
                                              //
                                              // update addon count
                                              if (
                                                filter.groupedAttachedAddons &&
                                                filter.groupedAttachedAddons.length >= 1 &&
                                                value > 1
                                              ) {
                                                dispatch(updateGroupAddon({ groupId: groupAddon.id, count: value }))
                                              }
                                              //
                                            }}
                                            minusOnClick={(value) => {
                                              // update addon count
                                              if (
                                                filter.groupedAttachedAddons &&
                                                filter.groupedAttachedAddons.length >= 1
                                              ) {
                                                dispatch(updateGroupAddon({ groupId: groupAddon.id, count: value }))
                                              }
                                              // remove addon by id
                                              if (
                                                filter.groupedAttachedAddons &&
                                                filter.groupedAttachedAddons.length >= 1 &&
                                                value === 0
                                              ) {
                                                //  remove addon by id
                                                dispatch(removeGroupAddon(groupAddon.id))
                                              }
                                            }}
                                          />
                                        </StandartAddon>

                                        {groupAddon?.addons?.map((innerGroupAddon, innerGroupAddonIndex) => (
                                          <GroupAddonDescription key={innerGroupAddonIndex}>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                              }}
                                            >
                                              <DoubleRightIcon />
                                              <span>{innerGroupAddon.addon.translations?.[lang]?.title}</span>
                                            </div>
                                            {filter.groupedAttachedAddons?.find((x) => x.addon.id === groupAddon.id) ? (
                                              <span className="offer-addon-description">
                                                {innerGroupAddon.description}
                                              </span>
                                            ) : null}
                                          </GroupAddonDescription>
                                        ))}
                                      </GroupAddon>
                                    )
                                  })}
                            </AddonsContent>
                          ) : null}
                        </AddonAccordion>
                      </AddonsBlock>
                    </>
                  ) : null}
                  {/* CONTENT */}
                </PriceAccordion>
              )
            })}
        </Block>
        <Content>
          <Buttons>
            <NavigationButton
              text={`${t('back')}`}
              buttonType="prev"
              onClick={() => [
                dispatch(setHeaderPassedCount(screenHeader.passedCount - 1)),
                navigate('/welcomer-choose-method'),
                dispatch(clearAddon([])),
                dispatch(clearGroupAddon([])),
              ]}
            />
            <NavigationButton
              disabled={filter.offer && filter.companyOffers && filter.companyOffers.length >= 1 ? false : true}
              text={`${t('next')}`}
              buttonType="next"
              onClick={() => [dispatch(setHeaderPassedCount(7)), navigate('/welcomer-offer')]}
            />
          </Buttons>
        </Content>
      </Container>
      <BackgroundIcon shortKite={true} />
    </Wrapper>
  )
}
//
//
//styles

const GroupAddonDescription = styled.p`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;

  svg {
    width: 11px;
    margin-right: 9px;
    margin-top: 1px;
  }

  .offer-addon-description {
    font-size: 14px;
    color: ${Colors.primaryBlack};
    margin-top: 10px;
    color: ${Colors.nevadaGrey};
  }
`
const StandartAddonLeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
  color: ${Colors.primaryBlack};
  text-align: left;

  span {
    :not(:first-child) {
      color: ${Colors.nevadaGrey};
    }
  }

  .offer-addon-description {
    margin-right: 20px;
    margin-top: 10px;
  }
`
const StandartAddon = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 22px;

  &:not(:last-child) {
    border-bottom: 1px solid ${Colors.secondaryGrey};
    padding-bottom: 22px;
  }
`
const GroupAddon = styled.div`
  margin-top: 22px;

  &:not(:last-child) {
    border-bottom: 1px solid ${Colors.secondaryGrey};
    padding-bottom: 22px;
  }

  ${StandartAddon} {
    margin-top: 0px;
    border-bottom: unset;
    padding-bottom: 0px;
  }
`
const AddonsContent = styled.div`
  /*  */
`
const RightArrowStyle = styled(RightArrow)`
  width: 20px;
  margin-left: auto;
  transform: scale(1.1);
`
const CubesIconStyle = styled(CubesIcon)`
  width: 32px;
  height: 32px;
  margin-right: 17px;
`
const AddonHead = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  span {
    font-size: 14px;
    color: ${Colors.primaryBlack};
  }
`
const AddonAccordion = styled.div`
  /*  */
`
const AddonsBlock = styled.div`
  /*  */
`
const RightText = styled.div``
const LeftText = styled.div``
const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  &:not(:last-child) {
    margin-bottom: 14px;
  }
`
const VerticalLine = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${Colors.secondaryGrey};
`
const DropdownCustomStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  .dropdown-value-span {
    position: absolute;
    z-index: 2;
    left: 10px;
    color: ${Colors.nevadaGrey};
    font-size: 14px;
    line-height: 14px;
    cursor: default;
    user-select: none;
    pointer-events: none;
  }
`
const DropDownBlock = styled.div`
  border: 1px solid ${Colors.secondaryGrey};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  margin-inline: auto;
  margin-top: 32px;
  width: 400px;
  height: 56px;
  margin-top: 32px;
  /*  */
  /*  */
  .dropdown-title-span {
    display: none;
  }
  .dropdown-wrapper {
    width: 100%;

    .v2-select__control {
      border: unset;
      background-color: transparent;
    }

    .v2-select__dropdown-indicator {
      padding: 0px;
    }

    .v2-select__single-value {
      display: flex;
      justify-content: flex-end;
      text-align: right;
    }
  }

  /*  */
  ${Responsive.mobile} {
    width: 100%;
    height: 48px;

    .dropdown-wrapper {
      .v2-select__value-container {
        padding-right: 10px;
      }
      .v2-select__dropdown-indicator {
        width: 24px;
      }
    }
  }
`

const HR = styled.hr`
  background-color: ${Colors.secondaryGrey};
  margin-block: 24px;
`
const Block = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  column-gap: 32px;
  row-gap: 20px;
  margin-top: 32px;
  padding-inline: 20px;
  position: relative;
  z-index: 2;

  ${Responsive.tablet} {
    flex-direction: column;
  }

  ${Responsive.mobile} {
    flex-direction: column;
    padding-inline: 0px;
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 48px;
  width: min-content;
  margin-inline: auto;
  z-index: 2;
  position: relative;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

const Content = styled.div`
  margin-top: 58px;
  width: 100%;
  padding-inline: 20px;
  z-index: 1;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
`

export default WelcomerOffers
